import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { MAINPAGE_PATH } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link component={RouterLink} to={MAINPAGE_PATH} aria-label="theme-logo" sx={{ display: 'flex', my: 'auto' }}>
        <Logo />
    </Link>
);

export default LogoSection;
